module.exports = __webpack_public_path__ + "img/nutsSmall.7159ae87.jpg";